
import { useEffect, useState } from "react";
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const useStripeInitializer = () => {
  const [stripePromise, setStripePromise] = useState<Promise<Stripe | null> | null>(null);
  const { toast } = useToast();

  useEffect(() => {
    const initializeStripe = async () => {
      try {
        const { data, error } = await supabase.functions.invoke('get-stripe-key');
        if (error) {
          console.error('Error fetching Stripe key:', error);
          throw error;
        }
        if (data?.publicKey) {
          setStripePromise(loadStripe(data.publicKey));
        }
      } catch (error) {
        console.error('Error initializing Stripe:', error);
        toast({
          title: "Error",
          description: "Failed to initialize payment system",
          variant: "destructive",
        });
      }
    };

    initializeStripe();
  }, [toast]);

  return stripePromise;
};
